// 新聞 收藏
import { useDispatch, useSelector } from 'react-redux';
import { userState } from '@/slices/userSlice';
import { setHintText, setShowHintModal, setShowLoginModal } from '@/slices/popSlice';
import { newsState, setNewsSocialCount } from '@/slices/newsSlice';
import newsClient from '@/common/apiClient/newsClient';

import Image from 'next/image';

const NewsCollectButton = ({ location, newsId }) => {
    const dispatch = useDispatch();
    const { user } = useSelector(userState);
    const { newsSocialCount } = useSelector(newsState);

    // 是否為進度條
    const isProgress = location === 'progress';

    // 收藏
    const onCollect = async () => {
        // 需登入
        if (!user?.uid) {
            dispatch(setShowLoginModal(true));
            return;
        }

        try {
            const { message } = await newsClient.collectNews(newsId);
            if (message === 'success') {
                dispatch(
                    setHintText(
                        newsSocialCount?.isFavorite === 1 ? 'HINT_COLLECT_CANCEL' : 'HINT_COLLECT'
                    )
                );
                dispatch(setShowHintModal(true));
                dispatch(
                    setNewsSocialCount({
                        favorite:
                            newsSocialCount?.favorite + (newsSocialCount?.isFavorite ? -1 : 1),
                        isFavorite: newsSocialCount?.isFavorite === 1 ? 0 : 1,
                    })
                );
            }
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <button
            onClick={onCollect}
            className={`${newsSocialCount?.isFavorite === 1 ? 'gtm-btn-cancel-collect' : 'gtm-btn-collect'} py-[2px] center-center rounded-[6px] group trans
            ${
                isProgress
                    ? 'pl-[6px] pr-[10px] gap-x-[10px]'
                    : `px-[20px] gap-x-[16px] hover:bg-bou ${
                          newsSocialCount?.isFavorite === 1 ? 'bg-bou' : ''
                      }`
            }`}
        >
            <div className="img-box w-[35px] aspect-[1]">
                <Image
                    className={
                        isProgress
                            ? `absolute trans group-hover:opacity-0 ${
                                  newsSocialCount?.isFavorite === 1 ? 'opacity-0' : ''
                              }`
                            : 'trans filter-white'
                    }
                    width={35}
                    height={35}
                    src={
                        isProgress
                            ? '/images/icon/icon_grey_collect.svg'
                            : '/images/icon/icon_white_collect.svg'
                    }
                    alt="icon"
                />
                {isProgress && (
                    <Image
                        className={`trans group-hover:opacity-[1] ${
                            newsSocialCount?.isFavorite === 1 ? 'opacity-[1]' : ''
                        }`}
                        width={35}
                        height={35}
                        src="/images/icon/icon_white_collect.svg"
                        alt="icon"
                    />
                )}
            </div>

            <span
                className={`text-btn1 flex-shrink-0 ${
                    isProgress
                        ? `text-black6 trans group-hover:text-bou ${
                              newsSocialCount?.isFavorite === 1 ? 'text-bou' : ''
                          }`
                        : 'text-white'
                }`}
            >
                {newsSocialCount?.isFavorite === 1 ? '已收藏' : '收藏'}
            </span>
        </button>
    );
};

export default NewsCollectButton;
